<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex flex-row-reverse w-100">
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="main">
              <mat-icon
                class="mb-4"
                style="transform: scale(2.5)"
                svgIcon="success"
              ></mat-icon>
              <p class="message mb-4 mt-3 text-center">
                Informações enviadas com sucesso.
              </p>
              <ng-container *ngIf="boobleModalData.analysisNeed === true">
                <p class="description-inbound mb-4">
                  Nosso time irá analisar as informações e documentos enviados e
                  te comunicaremos.
                </p>
                <button
                  (click)="closeModal()"
                  type="button"
                  class="btn btn-block mt-4 w-25"
                  [ngClass]="
                    companyId
                      ? 'btn-dark-primary-blue'
                      : 'btn-dark-primary-blue-pf'
                  "
                  type="button"
                >
                  Fechar
                </button>
              </ng-container>
              <ng-container *ngIf="boobleModalData.analysisNeed === false">
                <p class="description mb-4">
                  Você pode prosseguir para realizar uma cotação e avançar no
                  processo de recebimento, ou realizar a cotação em outro
                  momento.
                </p>
                <button
                  (click)="openQuotation()"
                  type="button"
                  class="btn mt-4"
                  [ngClass]="
                    companyId
                      ? 'btn-dark-primary-blue'
                      : 'btn-dark-primary-blue-pf'
                  "
                  type="button"
                >
                  Prosseguir para a cotação
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
